import { render, staticRenderFns } from "./TaskConfigEdit.vue?vue&type=template&id=94cfcc0a&"
import script from "./TaskConfigEdit.vue?vue&type=script&lang=js&"
export * from "./TaskConfigEdit.vue?vue&type=script&lang=js&"
import style0 from "./TaskConfigEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports